import { Box, Paper } from "@mui/material"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { NoResults } from "lib/@components/no-results/no-results"
import { If, Else } from "lib/@components/switch"
import { getUserProjects } from "authoring/users/projects/controller/get-user-projects"
import { hash } from "library/hash"
import { ArchivedProjectRow } from "./archived-project-row"

const tableHeaders = [{ title: "Name" }, { title: "Schedules", align: "right" }, { title: "Archived" }, { title: "" }]

export function ArchivedWorkPackagesList() {
    const result = getUserProjects.useResults({ archived: true, orderStmt: ["-$modified"] })
    const projects = result?.projects ?? []
    const ids = projects.map("id").sort().join(",")
    const key = ids ? hash(ids) : "archivedProjectTable"

    return (
        <Box sx={{ width: 1 }} data-cy="archived-work-packages-section">
            <If value={!!projects.length}>
                <TabledRepeat
                    key={key}
                    items={projects}
                    itemPass="project"
                    tableComponent={<Paper sx={{ boxShadow: 3 }} />}
                    itemComponent={<ArchivedProjectRow />}
                    tableHeaders={tableHeaders}
                    paged
                    alternating={false}
                />
                <Else>
                    <NoResults>There are no archived work packages.</NoResults>
                </Else>
            </If>
        </Box>
    )
}
